import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Fragment } from 'react';
import { FaRegTrashAlt, FaSearchPlus, FaEdit } from 'react-icons/fa';
import { SignalKinds } from '../../../../data/constants/SignalsKinds';
import Select from '../../../elements/Select';
import useEditRangeModal from '../hooks/useEditRangeModal';
const styles = css `
  width: 66px;
  padding: 0 !important;
  button {import useEditRangeModal from './../../../hooks/useEditRangeModal';

    background-color: transparent;
    border: none;
    padding: 5px;
  }

  button:disabled {
    opacity: 0.6;
  }
`;
const selectBoxStyle = {
    marginLeft: 2,
    marginRight: 2,
    border: 'none',
    height: '20px',
};
function ActionsColumn({ rowData, onHoverSignal, rowSpanTags, showKind, }) {
    const { editRange, deleteRange, changeRangeSignalKind, zoomRange } = useEditRangeModal(rowData);
    return (_jsxs(Fragment, { children: [showKind && (_jsx("td", { ...onHoverSignal, children: _jsx(Select, { onChange: changeRangeSignalKind, items: SignalKinds, defaultValue: rowData.tableMetaInfo.signal.kind, style: selectBoxStyle }) })), _jsxs("td", { ...rowSpanTags, css: styles, children: [_jsx("button", { type: "button", className: "delete-button", onClick: () => deleteRange(), children: _jsx(FaRegTrashAlt, {}) }), _jsx("button", { type: "button", className: "zoom-button", onClick: () => zoomRange(), children: _jsx(FaSearchPlus, { title: "Zoom to range in spectrum" }) }), _jsx("button", { type: "button", className: "edit-button", onClick: () => editRange(), children: _jsx(FaEdit, { color: "blue" }) })] })] }));
}
export default ActionsColumn;
